import { timeToPx } from "@suse-o11y/time-to-px";
import React from "react";

import { useTimelineContext, useTimelineRange } from "../_context";

import { TimelineControlElement } from "./TimelineControlElement";
import { TimelinePlayHead } from "./TimelinePlayHead";

export const TimelineTimestamp: React.FC<{
	compact: boolean;
}> = ({ compact }) => {
	const { timestamp, stageWidth, formatTimestamp } = useTimelineContext();
	const [timelineStart, timelineEnd, now] = useTimelineRange({
		play: timestamp == null,
		interval: 300,
		floor: "seconds",
	});

	const [time, px] =
		timestamp == null
			? [now, stageWidth]
			: [
					timestamp,
					timeToPx({
						time: timestamp,
						width: stageWidth,
						interval: { start: timelineStart, end: timelineEnd },
					}),
				];
	if (px < 0 || px > stageWidth) {
		return null;
	}

	if (compact) {
		return (
			<TimelineControlElement className="pointer-events-none inset-y-0" x={px}>
				<div className="h-full w-px bg-graphite-400" />
			</TimelineControlElement>
		);
	}

	return (
		<TimelinePlayHead className="inset-y-0" theme="dark" x={px}>
			{formatTimestamp({ time, timelineStart, timelineEnd, now }, px)}
		</TimelinePlayHead>
	);
};
